import { Controller } from "@hotwired/stimulus"

// Marks fields required only while the controlling "yes" radio is checked.
// The fields live in a container CSS hides when "no" is selected, and a
// hidden required input would block that submission — so requiredness must
// follow the radio. Fields opt in via data-required-when-checked (false in
// tests, matching the required: !Rails.env.test? convention elsewhere).
export default class extends Controller {
  static targets = ["field", "radio"]

  connect() {
    this.sync()
  }

  sync() {
    const on = this.radioTargets.some((radio) => radio.checked && radio.value === "true")

    this.fieldTargets.forEach((field) => {
      field.required = on && field.dataset.requiredWhenChecked === "true"
    })
  }
}
